(function () {
  function getParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name);
    } catch (e) {
      return null;
    }
  }

  function getHashParam(name) {
    try {
      var hash = window.location.hash.substring(1); // remove the #
      var params = new URLSearchParams(hash);
      return params.get(name);
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Check query param first, then hash fragment as fallback
  var promo = getParam("promo") || getHashParam("promo");
  if (promo) {
    setCookie("btc_promo", String(promo).toUpperCase(), 7);
  }

  window.BTC_PROMO = getCookie("btc_promo");

  if (window.BTC_PROMO) {
    document.documentElement.classList.add("btc-promo-active");
    document.documentElement.classList.add(
      "btc-promo-" + String(window.BTC_PROMO).toLowerCase()
    );
  }
})();